<div
  class="btn-group"
  dropdown
  placement="bottom"
  [isDisabled]="(1 | isReadonlyRole) || (!status?.canOpen && !status?.canClose)"
  *ngIf="status"
>
  <button type="button" class="btn dropdown-toggle" dropdownToggle [ngClass]="'btn-secondary-' + getStatusColor()">
    <i class="far fa-check" *ngIf="status?.canOpen && status?.canClose"></i>
    <i class="far fa-lock" *ngIf="!status?.canOpen && status?.canClose"></i>
    <i class="far fa-lock" *ngIf="!status?.canOpen && !status?.canClose"></i>
    <i class="far fa-circle" *ngIf="!status?.canClose && status?.canOpen"></i>
    <ng-container>{{ status?.code }}</ng-container>
  </button>
  <ul class="dropdown-menu dropdown-menu-right" *dropdownMenu>
    <li *ngIf="status.canOpen">
      <button type="button" (click)="onOpen()">
        <i class="far fa-lock"></i> <ng-container i18n>Open Property</ng-container>
      </button>
    </li>
    <li *ngIf="status.canClose">
      <button type="button" (click)="onClose()">
        <i class="far fa-circle"></i> <ng-container i18n>Close Property</ng-container>
      </button>
    </li>
  </ul>
</div>
